import { useContext, useEffect, useState } from "react";
import { getBatch, getSortedCollection } from "sprint-common-web";

import { SystemContext } from "../context/SystemContext";
import { SystemItem } from "./SystemItem";
import { SystemListingFilters } from "./useSystemListingFilters";

export const useSystemListing = (filters: SystemListingFilters) => {
    const [items, setItems] = useState<SystemItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { systemItems, isLoading } = useContext(SystemContext);

    useEffect(() => {
        if (systemItems.length) {
            getData();
        }
    }, [systemItems, filters.page, filters.pageSize, filters.sortBy, filters.sortOrder]);

    const getData = (): void => {
        const sortedItems = getSortedCollection(systemItems, filters.sortBy, filters.sortOrder);
        const itemsToDisplay = getBatch(sortedItems, filters.pageSize, filters.page);

        setTotalItems(sortedItems.length);
        setItems(itemsToDisplay);
    };

    return {
        items,
        totalItems,
        isLoading,
        getData
    };
};
